// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kspace .ant-space-item{overflow-y:auto}", "",{"version":3,"sources":["webpack://./../src/components/web-components/stacks/horizontal-stack.scss"],"names":[],"mappings":"AAAA,wBACI,eAAA","sourcesContent":[".kspace .ant-space-item {\n    overflow-y: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
